import classes from './CurencyCell.module.css'
import classesCell from './BodyCell.module.css'
import { formatCurrency } from '../../../lib/script'
import { miscellaneous } from '../../../lib/misc'
import { transportationFunctions } from '../../../lib/transportation'

export default function CurencyCell({text, itemKey, caseData, fullHeight}) {

    const transportation_funds_remaining_class = itemKey == 'transportation_funds_remaining' ?     
    transportationFunctions.isTransportationFundsRemainingBelowMinimum(caseData)    
    :     
    ''

    if (!text) {
        return <div className={`${classes.CurencyCell_cell} ${classesCell.body_cell}`}>
            -
        </div>
    }

    return <div className={`${classes.CurencyCell_cell} ${classesCell.body_cell} ${transportation_funds_remaining_class} ${fullHeight ? classes.full_height : ''}`}>
        ${miscellaneous.isNumber(text) ? formatCurrency(text) : <>{text}</>}     
    </div>
}